<template>
  <div id="assortment" class="assortment" v-if="catalogs.length">
    <div class="assortment__container container">
      <div class="assortment__inside">
        <div class="assortment__title title">
          <h2>
            <span>Каталог товаров TCL</span>
          </h2>
        </div>
        <div class="assortment__content">
          <div class="assortment__heading heading">
            Все технические жидкости<br>для вашего автомобиля<br>в одном бренде
          </div>
          <div class="assortment__items">
            <div class="assortment__inner">
              <a
                  v-for="(item, index) in catalogs"
                  :key="item.id"
                  :href="`/catalog/${item.id}`"
                  class="assortment__item"
              >
                <div class="assortment__top"></div>
                <div class="assortment__header">{{ item.title }}</div>
                <div class="assortment__bottom"></div>
                <img :src="categoryImage(item, index)" :alt="item.title"/>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WidgetCatalogJson from '@/assets/data/widget_catalog.json'
import { fetchProductCategories } from '../api/adminBrands'

const WIDGET_IMAGES = {
  1: require('@/assets/img/widget/widgetcatalog-1.jpg'),
  2: require('@/assets/img/widget/widgetcatalog-2.jpg'),
  3: require('@/assets/img/widget/widgetcatalog-3.jpg'),
  4: require('@/assets/img/widget/widgetcatalog-4.jpg'),
}

export default {
  data() {
    return {
      catalogs: [],
    }
  },
  methods: {
    categoryImage(item, index) {
      const title = this.normalizeTitle(item.title)
      const preset = (WidgetCatalogJson.data || []).find((row) => (
        this.normalizeTitle(row.title) === title
      ))
      if (preset && WIDGET_IMAGES[preset.id]) {
        return WIDGET_IMAGES[preset.id]
      }
      return WIDGET_IMAGES[(index % 4) + 1]
    },
    normalizeTitle(value) {
      return String(value || '').trim().toLowerCase()
    },
    sortByOrder(a, b) {
      const left = Number.isFinite(Number(a && a.sort_order)) ? Number(a.sort_order) : Number.MAX_SAFE_INTEGER
      const right = Number.isFinite(Number(b && b.sort_order)) ? Number(b.sort_order) : Number.MAX_SAFE_INTEGER
      if (left !== right) return left - right
      return String((a && a.title) || '').localeCompare(String((b && b.title) || ''), 'ru', { sensitivity: 'base' })
    },
  },
  async beforeMount() {
    try {
      const rows = await fetchProductCategories()
      this.catalogs = rows
        .filter((row) => row && row.id && String(row.title || '').trim())
        .slice()
        .sort(this.sortByOrder)
        .map((row) => ({
          id: row.id,
          title: String(row.title).trim(),
        }))
    } catch (e) {
      this.catalogs = []
    }
  },
}
</script>
